import { useState } from "react";
import { X, ChevronDown, ChevronRight } from "lucide-react";

export default function MobileMenu({ menus, close }) {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (id) => {
    setOpenSection(openSection === id ? null : id);
  };

  return (
    <div className="fixed inset-0 bg-[#071104] z-[60] flex flex-col animate-in fade-in slide-in-from-right duration-300">
      {/* Header */}
      <div className="flex justify-between items-center p-6 border-b border-white/10">
        <img src="/logo.png" alt="Logo" className="h-8 w-auto" />
        <button 
          onClick={close} 
          className="p-2 bg-white/5 rounded-full text-white hover:bg-white/10 transition-colors"
        >
          <X size={24} />
        </button>
      </div>

      {/* Navigation Links */}
      <div className="flex-1 overflow-y-auto p-6 space-y-4">
        {menus.map((menu) => {
          const isOpen = openSection === menu.id;
          
          return (
            <div key={menu.id} className="border-b border-white/5 pb-4">
              <button
                onClick={() => toggleSection(menu.id)}
                className="flex justify-between items-center w-full text-left group"
              >
                <span className={`text-xl font-bold transition-colors ${isOpen ? 'text-green-400' : 'text-white'}`}>
                  {menu.title}
                </span>
                {isOpen ? <ChevronDown className="text-green-400" /> : <ChevronRight className="text-white/40" />}
              </button>

              {/* Accordion Content */}
              <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-[1000px] mt-6' : 'max-h-0'}`}>
                <div className="space-y-8 pl-2">
                  {menu.columns.map((column, i) => (
                    <div key={i}>
                      <h4 className="text-sky-400 text-[10px] font-black uppercase tracking-widest mb-4 border-l-2 border-sky-500 pl-3">
                        {column.title}
                      </h4>
                      <div className="space-y-5">
                        {column.items.map((item, j) => (
                          <a
                            key={j}
                            href={item.url || "#"}
                            onClick={close}
                            className="block group"
                          >
                            <div className="font-semibold text-white group-hover:text-green-400 transition-colors">
                              {item.title}
                            </div>
                            {item.description && (
                              <p className="text-xs text-white/50 mt-1 line-clamp-1">
                                {item.description}
                              </p>
                            )}
                          </a>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Footer CTA */}
      <div className="p-6 bg-white/[0.02] border-t border-white/10">
        <a href="/#contact-us" onClick={close}>
          <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest shadow-lg shadow-green-500/20">
            Request a Demo
          </button>
        </a>
      </div>
    </div>
  );
}